import { api } from '@services';

import Contact, { IContact, IContactApiModel } from '@models/Contact.model';

interface INewContact {
  manufacturerId?: string;
  productIds?: string[];
  haveOwnerStudio?: boolean;
  name: string;
  title?: string;
  isGlobal?: boolean;
  emails?: Array<{ email: string; label: string }>;
  phones?: Array<{ phone: string; label: string }>;
}
interface IManufacturerVariables {
  data: INewContact;
}

const addContact = async ({
  data,
}: IManufacturerVariables): Promise<IContact> => {
  const { data: contact } = await api.post<IContactApiModel>(`/contacts`, data);

  return Contact.fromApiModel(contact);
};

export { addContact };
